import React from "react";
const ApplicationNote = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 21}
    height={props?.height || 20}
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.16669 3.33594C3.16669 1.95523 4.28598 0.835938 5.66669 0.835938H15.6667C17.0474 0.835938 18.1667 1.95523 18.1667 3.33594V16.6693C18.1667 18.05 17.0474 19.1693 15.6667 19.1693H5.66669C4.28598 19.1693 3.16669 18.05 3.16669 16.6693V3.33594ZM9.46544 4.72232C9.58394 4.39066 9.8981 4.16927 10.2503 4.16927H11.0836C11.4358 4.16927 11.7499 4.39066 11.8684 4.72232L13.9517 10.5557C14.1065 10.9891 13.8806 11.4659 13.4472 11.6207C13.0138 11.7755 12.5369 11.5496 12.3821 11.1162L11.8356 9.58594H9.49819L8.95169 11.1162C8.7969 11.5496 8.32006 11.7755 7.88664 11.6207C7.45321 11.4659 7.22734 10.9891 7.38213 10.5557L9.46544 4.72232ZM11.2404 7.91927L10.6669 6.31361L10.0934 7.91927H11.2404ZM7.33335 13.3359C6.87312 13.3359 6.50002 13.709 6.50002 14.1693C6.50002 14.6295 6.87312 15.0026 7.33335 15.0026H14C14.4603 15.0026 14.8334 14.6295 14.8334 14.1693C14.8334 13.709 14.4603 13.3359 14 13.3359H7.33335Z"
      fill="#4B68C6"
    />
  </svg>
);
export default ApplicationNote;
